/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback, useRef } from 'react'

const useDebounce = <T extends (...args: any[]) => void>(callback: T, delay = 100) => {
  const timeout = useRef<number>()
  const start = useRef<number>()

  const debounce = useCallback(
    (...args: Parameters<T>) => {
      if (timeout.current) {
        start.current = undefined
        window.cancelAnimationFrame(timeout.current)
      }

      const requestFn = function (timestamp: number) {
        if (!start.current) {
          start.current = timestamp
        }
        const elapsed = timestamp - start.current

        if (elapsed < delay) {
          timeout.current = window.requestAnimationFrame(requestFn)
          return
        }

        if (timeout.current) {
          window.cancelAnimationFrame(timeout.current)
        }

        callback(...args)
      }

      timeout.current = window.requestAnimationFrame(requestFn)
    },
    [callback, delay],
  )

  return debounce
}

export default useDebounce
